import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-semantic-toasts';
import { Header } from 'semantic-ui/semantic-ui-imports';
import { useData } from '../../contexts/data';
import { getAggregates } from '../../services/aggregate';
import { AggregateOption, HeatexRotor } from '../../Types/Aggregates';
import Fan from '../../Types/Fan';
import Filter from '../../Types/Filter';
import FilterSelect from '../FormInputs/FilterSelect';

interface Props {
  updateField: (
    name: string,
    value: string | number | boolean | (string | number | boolean)[] | undefined
  ) => void;
}

const classId = 'aggregate-expert-selections';

const AggregateExpertSelections = ({ updateField }: Props) => {
  const [heatex, setHeatex] = React.useState<HeatexRotor[]>([]);
  const [fans, setFans] = React.useState<Fan[]>([]);
  const [supplyFilters, setSupplyFilters] = React.useState<Filter[]>();
  const [dischargeFilters, setDischargeFilters] = React.useState<Filter[]>();
  const [selectedAggregate, setSelectedAggregate] = React.useState<
    AggregateOption | undefined
  >();

  const { activeUserInputs, activeAggregate } = useData();

  const { t } = useTranslation();

  const getAggregateOptions = async () => {
    try {
      const res = await getAggregates();
      const as = res?.results || [];
      if (!selectedAggregate && activeAggregate) {
        setSelectedAggregate(as.find((a) => a.id === activeAggregate?.id));
      }
    } catch (err) {
      toast({
        type: 'error',
        title: t('common.somethingWentWrong'),
        time: 4000,
        size: 'small',
      });
    }
  };

  const getData = async () => {
    if (!selectedAggregate) {
      return;
    }
    setHeatex(selectedAggregate?.heatex_rotors);
    setFans(selectedAggregate?.fans);
    setDischargeFilters(selectedAggregate?.discharge_filters);
    setSupplyFilters(selectedAggregate?.supply_filters);
  };

  React.useEffect(() => {
    getAggregateOptions();
  }, []);

  React.useEffect(() => {
    getData();
  }, [selectedAggregate]);

  return (
    <div className={classId}>
      <div>
        {/* <FilterSelect
          name="powerSupply"
          label={t('productPage.powerSupply')}
          defaultValue={
            activeUserInputs?.powerSupply || PowerSupplyOptions[0].key
          }
          onChange={(name, value) => updateField(name, value)}
          options={PowerSupplyOptions}
        /> */}
        {/* <FilterSelect
          name="aggregate"
          label={t('common.aggregate')}
          defaultValue={activeUserInputs?.aggregate || activeAggregate?.id}
          onChange={(name, value) => {
            const a = aggregates.find((x) => x.id === value);
            if (a) {
              setSelectedAggregate(a);
            }
            updateField(name, value);
          }}
          options={aggregates.map((obj, i) => ({
            text: obj.name,
            key: `${obj.id}_${i}`,
            value: obj.id,
          }))}
        /> */}
        {!!heatex?.length && (
          <FilterSelect
            name="heatex_rotor"
            label={t('common.heatex')}
            defaultValue={activeUserInputs?.heatex_rotor}
            onChange={(name, value) => updateField(name, value)}
            options={heatex.map((obj, i) => ({
              text: obj.name,
              key: `${obj.id}_${i}`,
              value: obj.id,
            }))}
          />
        )}
        {/* {!!compressors?.length && (
          <FilterSelect
            multiple
            name="compressor"
            label={t('common.compressor')}
            defaultValue={activeUserInputs?.compressor}
            onChange={(name, value) => updateField(name, value)}
            options={compressors.map((obj, i) => ({
              text: obj.name,
              key: `${obj.id}_${i}`,
              value: obj.id,
            }))}
          />
        )} */}
        {!!fans?.length && (
          <FilterSelect
            name="fan"
            label={t('common.fan')}
            defaultValue={activeUserInputs?.fan}
            onChange={(name, value) => updateField(name, value)}
            options={fans.map((obj, i) => ({
              text: obj.name,
              key: `${obj.id}_${i}`,
              value: obj.id,
            }))}
          />
        )}
      </div>
      <div>
        <Header>{t('common.filterClass')}</Header>
        {!!supplyFilters?.length && (
          <FilterSelect
            name="supply_filter"
            label={t('common.supplyFilter')}
            defaultValue={activeUserInputs?.supply_filter}
            onChange={(name, value) => updateField(name, value)}
            options={supplyFilters.map((obj, i) => ({
              text: obj.name,
              key: `${obj.id}_${i}`,
              value: obj.id,
            }))}
          />
        )}
        {!!dischargeFilters?.length && (
          <FilterSelect
            name="discharge_filter"
            label={t('common.dischargeFilter')}
            defaultValue={activeUserInputs?.discharge_filter}
            onChange={(name, value) => updateField(name, value)}
            options={dischargeFilters.map((obj, i) => ({
              text: obj.name,
              key: `${obj.id}_${i}`,
              value: obj.id,
            }))}
          />
        )}
      </div>
    </div>
  );
};

export default AggregateExpertSelections;
